
import { useEffect, useState } from 'react'
import React from 'react'
import{Box,Stack,Typography}from '@mui/material'
import { useParams } from 'react-router-dom'
import Sidebar from './Sidebar'

import { fetchFromAPI } from '../utils/fetchFromAPI'
import Videos from './Videos'

const SearchFeed = () => {
  
  const [videos, setVideos] = useState([]);
  const {searchTerm} = useParams();
useEffect(()=>{
fetchFromAPI(`search?part=snippet&q=${searchTerm}`)
.then((data)=>setVideos(data.items));

},[searchTerm]);
  return (
    <Box p={2} sx={{
      overflowY: 'auto', height: '90vh', Flex:2
      }}>
      
        <Typography variant="h4"
         fontWeight="bold" mb={2} sx={{
          color: 'white'
         }}  >
          Search Result for:<span style={{
            color: '#F31503', 
          }} >{searchTerm}</span> videos
        </Typography>
      
        <Videos videos={videos} />
      </Box>
  )
}

export default SearchFeed